// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generic-btn {
  color: #111111;
  font: 12px Poppins, "Helvetica Neue", sans-serif;
  background: #f2f2f2;
  margin: 0px 8px 0px 0px;
  padding: 5px 8px;
}
/* added by ashok */
.goto-input {
  width: 60px;
  text-align: center;
  border: 1px solid #b6b5b5eb;
  border-radius: 3px;
  margin-left: 15px;
  outline: none;
}
.select-pagesize {
  text-align: center;
  border: 1px solid #b6b5b5eb;
  border-radius: 3px;
  margin-left: 15px;
  padding: 2px;
  font-size: 14px;
  outline: none;
  color: #333333;
}
.goto-indi {
  font-family: "HelveticaNeue-Medium", "Helvetica Neue Medium", "Helvetica Neue",
    sans-serif;
}
.details-nav-container {
  background-color: #f6f6f9;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  margin-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
}
.table-nav-btn {
  border: 0;
  color:#1e356f;
  font-weight: 500;
  /* box-shadow: 0px 0px 1px 0px rgb(105, 102, 105); */
  background-color: rgba(139, 246, 210, 0.226);
}
.disabled-nav-btn {
  border: 0;
  color: #333333;
  box-shadow: 0px 0px 1px 0px rgb(105, 102, 105);
  background-color: #dadada4b;
  /* display: none; */
}
.nav-btn-cont {
  display: flex;
  min-width: 250px;
  justify-content: space-between;
}


.cell{
  word-break: break-all;
  max-height: 50px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/components/feedetailstable/FeeDetailsTable.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gDAAgD;EAChD,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE;cACY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,oDAAoD;EACpD,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,cAAc;EACd,8CAA8C;EAC9C,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".generic-btn {\n  color: #111111;\n  font: 12px Poppins, \"Helvetica Neue\", sans-serif;\n  background: #f2f2f2;\n  margin: 0px 8px 0px 0px;\n  padding: 5px 8px;\n}\n/* added by ashok */\n.goto-input {\n  width: 60px;\n  text-align: center;\n  border: 1px solid #b6b5b5eb;\n  border-radius: 3px;\n  margin-left: 15px;\n  outline: none;\n}\n.select-pagesize {\n  text-align: center;\n  border: 1px solid #b6b5b5eb;\n  border-radius: 3px;\n  margin-left: 15px;\n  padding: 2px;\n  font-size: 14px;\n  outline: none;\n  color: #333333;\n}\n.goto-indi {\n  font-family: \"HelveticaNeue-Medium\", \"Helvetica Neue Medium\", \"Helvetica Neue\",\n    sans-serif;\n}\n.details-nav-container {\n  background-color: #f6f6f9;\n  margin-top: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 50px;\n  margin-left: 20px;\n  padding-right: 20px;\n  margin-bottom: 20px;\n}\n.table-nav-btn {\n  border: 0;\n  color:#1e356f;\n  font-weight: 500;\n  /* box-shadow: 0px 0px 1px 0px rgb(105, 102, 105); */\n  background-color: rgba(139, 246, 210, 0.226);\n}\n.disabled-nav-btn {\n  border: 0;\n  color: #333333;\n  box-shadow: 0px 0px 1px 0px rgb(105, 102, 105);\n  background-color: #dadada4b;\n  /* display: none; */\n}\n.nav-btn-cont {\n  display: flex;\n  min-width: 250px;\n  justify-content: space-between;\n}\n\n\n.cell{\n  word-break: break-all;\n  max-height: 50px;\n  overflow: auto;\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 200px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
